/**
 * File pageLoadAnimations.js
 *
 * Handles global page load animations
 */

document.addEventListener('DOMContentLoaded', function() {
    let quickAnimationEles = document.querySelectorAll('.mo-quick-animate-on-page-load');
    if( quickAnimationEles ) {
        quickAnimationEles.forEach((ele) => {
            ele.classList.add('mo-trigger-animation');
        });
    }

    if( document.body.classList.contains('home') ) {
        setTimeout(() => {
            document.body.classList.add( 'mo-page-loaded' );
        }, "1650");
    } else {
        setTimeout(() => {
            document.body.classList.add( 'mo-page-loaded' );
        }, "100");
    }

    // Mobile 100vh to account for ios elements // scoure: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    // We listen to the resize event
    // window.addEventListener('resize', () => {
    //     // We execute the same script as before
    //     let vh = window.innerHeight * 0.01;
    //     document.documentElement.style.setProperty('--vh', `${vh}px`);
    // });
}, false);